export default __webpack_public_path__ + "static/media/prusa-icons-set-logo.a5447eeb.svg";